<template>
  <div class="tw-pb-4">
    <span
      class="
        tw-text-center
        tw-hidden
        tw-justify-center
        tw-font-medium
        tw-text-[#EE2828]
        tw-my-1
        xl:tw-flex
      "
      :class="{ invisible: !error }"
      >{{ error }}&nbsp;
    </span>
    <h3
      class="
        tw-text-center tw-text-sm tw-font-medium tw-text-gray-subtitle
        xl:tw-text-lg
      "
    >
      {{ title }}
    </h3>
    <span
      class="
        tw-text-center
        tw-flex
        tw-justify-center
        tw-font-medium
        tw-text-[#EE2828]
        tw-my-2
        xl:tw-hidden
      "
      :class="{ invisible: !error }"
      >{{ error }}&nbsp;
    </span>
    <div class="xl:tw-w-3/4 tw-w-3/5 tw-mx-auto">
      <slot></slot>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    error: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
